
import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
// import { OtpVerify } from './OtpVerify';
import {
  setShowEmailAciton
} from 'common/commonRedux/auth/actions';
import { useAxiosRequest } from 'common/hooks';

import {
  Alert,
  Button,
  Form,
  Input
} from 'antd';
import { useIsDark } from 'common/hooks';
import SelectedPlanBanner from 'modules/auth/signUp/SelectedPlanBanner';
import logo from './logo.png';
import OtpVerify from './OtpVerify';
const OtpSend = () => {
  const isDark = useIsDark();
  const [isShow, setIsShow] = useState(false);
  const [trialError, setTrialError] = useState<string>('');
  const { auth } = useSelector((state: any) => state, shallowEqual);
  const signupContext =
    useSelector((state: any) => state.auth?.profileData?.signupContext) || {};
  const isTrial: boolean = !!signupContext.isTrial;
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const postSendOtp = useAxiosRequest(null);
  const checkTrial = useAxiosRequest(null);
  const [form] = Form.useForm();


  useEffect(() => {
    if (auth.isAuth) {
      navigate('/');
    }
  }, [auth]);

  const sendOtp = (email: string) => {
    postSendOtp.apiAction({
      urlObjKey: 'SendOtpforVerifyEmail',
      params: { email },
      method: 'POST',
      isToast: true,
      cb: () => {
        form.resetFields();
        setIsShow(true);
        dispatch(setShowEmailAciton(email));
      },
      onError: (error) => {
        console.error('Otp send fail:', error);
      },
    });
  };

  const onFinish = (values: any) => {
    const email = values.email?.trim();
    setTrialError('');

    if (!isTrial) {
      sendOtp(email);
      return;
    }

    checkTrial.apiAction({
      urlObjKey: 'CheckTrialStatus',
      method: 'POST',
      payload: { email },
      cb: (data: any) => {
        const eligible = data?.isEligible === true;
        if (!eligible) {
          setTrialError(
            data?.message ||
            data?.Message ||
            'This email is not eligible for a free trial.'
          );
          return;
        }
        sendOtp(email);
      },
      onError: (err: any) => {
        setTrialError(
          err?.response?.data?.message ||
          err?.response?.data?.Message ||
          'This email is not eligible for a free trial.'
        );
      },
    });
  };

  const onFinishFailed = () => { };
  return (
    <div className=' w-full flex justify-center items-center'>
      {
        !isShow ?
          <div className='w-full'>
            <div className=" w-full flex justify-center">
              <div className='flex flex-col justify-center items-center gap-4 z-50'>
                <Link to="/" ><img src={logo} alt="Trackforce Logo" className='w-[120px] max-w-[200px] object-contain ' /></Link>
                <h1 className={`text-3xl font-semibold ${isDark ? 'text-white' : 'text-[#334155]'}`}>
                  {isTrial ? 'Start Your Free Trial' : 'Verify Your Email'}
                </h1>
              </div>
            </div>
            <div className="mt-4">
              <SelectedPlanBanner isDark={isDark} />
            </div>
            <div className="mt-6">
              {trialError && (
                <Alert
                  type="error"
                  message={trialError}
                  showIcon
                  className="mb-4"
                  closable
                  onClose={() => setTrialError('')}
                />
              )}
              <Form
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                {/* Work Email */}
                <Form.Item
                  label={
                    <span className={`text-md font-bold ${isDark ? 'text-white' : 'text-[#333]'}`}>
                      Email <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  name="email"
                  required={false}
                  rules={[
                    { required: true, message: 'Please enter your email!' },
                    { type: 'email', message: 'Enter a valid email address!' },
                  ]}
                >
                  <Input size='large' placeholder="Enter your email" />
                </Form.Item>
                {/* Submit Button */}
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="bg-primaryColor font-bold text-[#FFFFFF] rounded-[8px]"
                    block
                    iconPosition='end'
                    size='large'
                    loading={checkTrial.isLoading || postSendOtp.isLoading}
                  >
                    {checkTrial.isLoading
                      ? 'Checking eligibility'
                      : postSendOtp.isLoading
                        ? 'Processing'
                        : isTrial
                          ? 'Continue'
                          : 'Verify Email'}
                  </Button>
                </Form.Item>
              </Form>
            </div>
            {/* <Divider >Or</Divider> */}
            <div>
              {/* <div className='grid grid-cols-2 justify-center items-center gap-2'>
                <Button
                  block
                  disabled
                  className={`border rounded-xl h-11 text-md font-semibold flex items-center justify-center ${isDark ? 'border-[#2E3138] !text-white' : 'border-[#DCE3E3] text-[#000000]'}`}
                >
                  <GoogleIcon />
                  <span className="tracking-[-0.16px]">Sign up with Google</span>
                </Button>
                <Button
                  block
                  disabled
                  className={`border rounded-xl h-11 text-md font-semibold ${isDark ? 'border-[#2E3138] !text-white' : 'border-[#DCE3E3] text-[#000000]'}`}
                >
                  <SsoIcon />
                  <span className=" tracking-[-0.16px"> Sign up with SSO</span>
                </Button>
              </div> */}
              <p className={`text-center w-full mt-4 ${isDark ? 'text-[#CBD5E1]' : 'text-[#334155]'}`}>
                Already have an account?{' '}
                <Link
                  to={`/login`}
                  className="text-sm text-primaryColor font-semibold"
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
          : <OtpVerify />
      }
    </div>
  )
}

export default OtpSend
